import { Component, HostListener, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabChangeEvent } from '@angular/material/tabs';
import { GridApi, RowGroupingDisplayType, GridOptions } from 'ag-grid-community';
import { CheckboxFieldComponent } from '../core/ag-grid/checkbox-field/checkbox-field.component';
import { DateFieldComponent } from '../core/ag-grid/date-field/date-field.component';
import { DropdownFieldFilterComponent } from '../core/ag-grid/dropdown-field-filter/dropdown-field-filter.component';
import { DropdownFieldComponent } from '../core/ag-grid/dropdown-field/dropdown-field.component';
import { NumberFieldComponent } from '../core/ag-grid/number-field/number-field.component';
import { TextareaFieldComponent } from '../core/ag-grid/textarea-field/textarea-field.component';
import { formatDate } from '@angular/common';
import { AgGridSortingService } from '../services/ag-grid-sorting.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LookupService } from '../services/lookup.service';
import { lastValueFrom } from 'rxjs';
import { ErrorMessageService } from '../services/error-message.service';
import { BusinessEntityService } from '../services/business-entity.service';
import { Router } from '@angular/router';
import { AssumedRoleStoreService } from '../services/assumed-role-store.service';
import { SupplierDetailsEditComponent } from '../core/ag-grid/supplier-details-edit/supplier-details-edit.component';
import { ManagementService } from '../services/management.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrl: './reports.component.css'
})
export class ReportsComponent {
@ViewChild('tabGroup') tabGroup: MatTabGroup;
  selectedTabIndex=0;
  domLayout='normal';
  gridApi: GridApi;
  gridColumnApi: any;
  gridApiMap = new Map<string, any>();
  groupDisplayType: RowGroupingDisplayType = "groupRows";
  gridOptions: GridOptions = {
    onColumnResized: () => this.autoSizeAllColumns(),
    onColumnMoved: () => this.autoSizeAllColumns()
  };
  columnDefAllSupplierDetails = []
  columnDefHistorySupplierDetails = []
  downloadFileFormatHistory = 'xlsx'
  excelStyles: any[]
  downloadFileFormatAll = 'xlsx'
  tooltipShowDelay = 100
  employeeId: number
  showNoSupplierErrMsg: boolean;
  pageErrorMsg: any;
  rowdataForHistorySupplierDetails = []
  rowdataForAllSupplierDetails = []
  reportPeriodData = []
  evaluationValues = []
  legitStatusValues = []
  unionStatusValues = []
  unionTypeValues = []
  limit = 1000;
  successMssg = '';
  gridContext = {
    currentlyEditingRow: null,
    tempEditData: {}  // Keyed by row ID or index
  }
  defaultColDef={ 
    suppressNavigable: true, suppressMovable: false, cellClass: 'no-border', enableRowGroup: true, unSortIcon: true,
    floatingFilter: true, filter: 'agTextColumnFilter', wrapText: true, suppressHeaderMenuButton: true,
    minWidth: 140, suppressFloatingFilterButton: true, autoHeight: true, sortable: true
  };
  icons = { menu: ' ', filter: ' ' }
  loginUserName: any;
  loginUserRole: string;
  cancelAssumedUser = false;
  displayUnauthorized = false;
  displayScreen: boolean;
  dateFilterParams: any;
  reportId: any;
  disableExportHistory = true;
  disableExportAll = true;
  checkValidity: any;
  selectedReportPeriodName: any;
  showSuccessMsg: boolean;
  filterDataValue: any;
  showErrorMsg: boolean;
  showOverallStatusCommentErrMsg: boolean;
  showEvaluationErrMsg: boolean;
  showUnionTypeErrMsg: boolean;
  evaluationErrorMsg: string;
  overallStatusCommentErrorMsg: string;
  bankBuildContingencyPlan = 'Bank Build on Contingency Plan?';
  bankVerifiedN1 = 'Bank Build Verified by N-1?'
  expectedNewContractCompletionDate = 'Expected New Contract Completion Date';
  contingencyPlan = 'Contingency Plan Developed/ On Schedule';
  noneSelected = 'None-Selected'
  unionTypeErrorMsg = '';

  constructor(private readonly sortService: AgGridSortingService, private readonly ngxSpinner: NgxSpinnerService, private readonly router: Router,
    private readonly lookup: LookupService, private readonly errorService: ErrorMessageService, private readonly bservice: BusinessEntityService,
    private readonly assumeRole: AssumedRoleStoreService, private readonly management: ManagementService) {
      this.dateFilterParams = {
        comparator: function (filterLocalDateAtMidnight, cellValue) {
          if (!cellValue) { return -1 };
          const cellDate = new Date(cellValue);
          const cellUTCDate = Date.UTC(cellDate.getUTCFullYear(), cellDate.getUTCMonth(), cellDate.getUTCDate());
          const filterUTCDate = Date.UTC(
            filterLocalDateAtMidnight.getFullYear(),
            filterLocalDateAtMidnight.getMonth(),
            filterLocalDateAtMidnight.getDate()
          );
          if (cellUTCDate === filterUTCDate) { return 0 };
          return cellUTCDate < filterUTCDate ? -1 : 1;
        },
        browserDatePicker: true,
      }
      this.excelStyles = [
      {
        id: 'header',
        interior: { color: "#D3D3D3", pattern: "Solid" },
        alignment: { horizontal: "Center", vertical: "Center", wrapText: true },
        font: { bold: true },
        borders: {
          borderTop: { color: '#333333', lineStyle: 'Continuous', weight: 1 },
          borderRight: { color: '#333333', lineStyle: 'Continuous', weight: 1 },
          borderBottom: { color: '#333333', lineStyle: 'Continuous', weight: 1 },
          borderLeft: { color: '#333333', lineStyle: 'Continuous', weight: 1 }
        }
      },
      {
        id: 'cell',
        alignment: { horizontal: "Left", vertical: "Center", wrapText: true },
        borders: {
          borderTop: { color: '#333333', lineStyle: 'Continuous', weight: 1 },
          borderRight: { color: '#333333', lineStyle: 'Continuous', weight: 1 },
          borderBottom: { color: '#333333', lineStyle: 'Continuous', weight: 1 },
          borderLeft: { color: '#333333', lineStyle: 'Continuous', weight: 1 }
        }
      },
      {
        id: 'statusRed', interior: { color: '#ff7276', pattern: 'Solid' }
      },
      {
        id: 'statusOrange', interior: { color: '#FFA500', pattern: 'Solid' }
      },
      {
        id: 'statusLightGreen', interior: { color: '#c4ee90', pattern: 'Solid' }
      },
      {
        id: 'statusYellow', interior: { color: '#ffe900',  pattern: 'Solid' }
      },
      {
        id: 'statusGreen', interior: { color: '#00b740', pattern: 'Solid' }
      },
      {
        id: 'statusLightPink', interior: { color: '#f1abb9', pattern: 'Solid' }
      },
      {
        id: 'statusGrey', interior: { color: '#b9b9b9', pattern: 'Solid' }
      }
    ]
  }

  async ngOnInit() {
    localStorage.setItem('clickedAllTab','false') // Setting flag to track if we're on All Tab, to make condtion for non-editable field in Reports -> All Tab. //Used only for checkbox-field-component fields.
    this.ngxSpinner.show();
    this.checkValidity = this.lookup.localStorageData.subscribe(async data => { 
      if(data?.includes('success')){
        this.displayUnauthorized = false;
        this.displayScreen = true;
        this.employeeId=this.bservice.loggedUserEmployeeId;
        this.loginUserName = this.bservice.loggedUserEmployeenameOriginal;
        const localStorageAssumeUser= JSON.parse(localStorage.getItem('userAssumed'));
        if(localStorageAssumeUser){
          this.assumeRole.assumeRoleByLocalStorage(localStorageAssumeUser)
        }else{
          this.assumeRole.assumeRoleByBService()
        }
        await this.getReportPeriod()
        await this.getUnionFilterData()
        this.setColumnDataValuesHistory()
        this.setColumnDataValuesAll()
		  } else if(data?.includes('failure')) {
        this.displayUnauthorized = true;
        this.displayScreen = false;
        const localStorageAssumeUser = localStorage.getItem('userAssumedData');
        if (localStorageAssumeUser==='noData') {
          this.cancelAssumedUser = true;
        }
        this.ngxSpinner.hide();
      }
    })
  }

  onTabChanged(event: MatTabChangeEvent) {
    if(event.index === 0) {
      localStorage.setItem('clickedAllTab','false')
      if(this.rowdataForHistorySupplierDetails.length <= 0) {
        this.getReportPeriod()
      }
    }
    if(event.index === 1) {
      localStorage.setItem('clickedAllTab','true')
      if(this.rowdataForAllSupplierDetails.length <= 0) {
        this.getAllDataDetails(this.employeeId, 1)
      }
    }
  }

  async getReportPeriod() {
    try {
      const data = await lastValueFrom(this.lookup.getReportPeriod())
      if(data.statusCode === 200 &&  !data?.body?.errorResponse) {
        if(data.body.history && data.body.history.length > 0) {
          this.reportPeriodData = data.body.history
          this.reportId = this.reportPeriodData[0].unionreportperiodid
          this.selectedReportPeriodName = this.reportPeriodData[0].name
          this.getSelectedReportPeriod(this.reportId)
        } else {
          window.scroll(0,0);
          this.ngxSpinner.hide()
          this.showErrorMessageReports(this.errorService.noReportPeriodAvailable)
        }
      } else {
        window.scroll(0,0);
        this.ngxSpinner.hide()
        this.showErrorMessageReports(this.errorService.serverErrMsg)
      }
    } catch {
      window.scroll(0,0);
      this.ngxSpinner.hide()
      this.showErrorMessageReports(this.errorService.serverErrMsg)
    }
  }

  async getUnionFilterData() {
    const data = await lastValueFrom(this.lookup.getUnionFilters())
    if(data.statusCode === 200 &&  !data?.body?.errorResponse) {
      this.lookup.setFilterData(data)
      this.unionTypeValues = ['All', ...(data.body?.unionType ?? []).map(value => value.uniontype)];
      this.unionStatusValues = ['All', ...(data.body?.unionStatus ?? []).map(value => value.unionstatus)];
      this.evaluationValues = ['All', ...(data.body?.evaluation ?? []).map(value => value.greekletter)];
      this.legitStatusValues = ['All', ...(data.body?.legit ?? [])];
    } else {
      window.scroll(0,0);
      this.ngxSpinner.hide()
      this.showErrorMessageReports(this.errorService.notAbleToGetFilterDetails)
    }
  }
  
  setColumnDataValuesHistory() {
    this.columnDefHistorySupplierDetails = [
      {
        headerName: 'Supplier Code',
        field: 'suppliercode', width: 140,
        lockPosition: true, pinned: 'left', lockPinned: true
      },
      {
        headerName: 'Supplier Name',
        field: 'suppliername', width: 140,
        lockPosition: true, pinned: 'left', lockPinned: true,
        comparator: this.sortService.stringComparator
      },
      {
        headerName: 'Commodity',
        field: 'commodity', width: 180,
        comparator: this.sortService.stringComparator
      },
      {
        headerName: 'NAMCs Supplied',
        field: 'namc', flex: 1,
        comparator: this.sortService.stringComparator
      },
      {
        headerName: 'City',
        field: 'plantcity', flex: 1,
        comparator: this.sortService.stringComparator
      },
      {
        headerName: 'State',
        field: 'plantstate', flex: 1, comparator: this.sortService.stringComparator
      },
      {
        headerName: 'Union Name (DMH)',
        field: 'unionname', flex: 1, comparator: this.sortService.stringComparator
      },
      {
        headerName: 'Union Type', field: 'uniontype', flex: 1, cellRenderer: DropdownFieldComponent, floatingFilterComponent: DropdownFieldFilterComponent,
        floatingFilter: true, floatingFilterComponentParams: { associatedList: this.unionTypeValues },
      },
      {
        headerName: 'Contract Expiration Date (DMH)',
        field: 'expirationdate', flex: 1,
        filter: 'agDateColumnFilter', filterParams: this.dateFilterParams,
        cellRenderer: (params) => { return this.formatDate(params.value) }
      },
      {
        headerName: 'Legit Planned Date',
        field: 'legitimizationdate', flex: 1,
        filter: 'agDateColumnFilter', filterParams: this.dateFilterParams,
        cellRenderer: DateFieldComponent
      },
      {
        headerName: 'Legit Complete',
        field: 'legitimizationstatus', flex: 1,
        cellRenderer: DropdownFieldComponent,
        floatingFilterComponent: DropdownFieldFilterComponent, floatingFilter: true,
        floatingFilterComponentParams: {
          associatedList: this.legitStatusValues
        }
      },
      {
        headerName: "MX Gov't. Apprvl. Date (DMH)",
        field: 'mxapprovaldate', flex: 1,
        filter: 'agDateColumnFilter', filterParams: this.dateFilterParams,
        cellRenderer: (params) => {
          return this.formatDate(params.value)
        }
      },
      {
        headerName: 'Overall Status Comment',
        field: 'comment', width: 240,
        cellRenderer: TextareaFieldComponent,
        comparator: this.sortService.stringComparator
      },
      {
        headerName: 'Inventory Bank (Days)',
        field: 'inventorybank', flex: 1,
        cellRenderer: NumberFieldComponent
      },
      {
        headerName: this.bankBuildContingencyPlan,
        field: 'bankbuildoncontingencyplan', flex: 1,
        cellRenderer: CheckboxFieldComponent, floatingFilterComponent: DropdownFieldFilterComponent,
        floatingFilter: true,
        floatingFilterComponentParams: {
          associatedList: ['All','Checked','Unchecked']
        },
        headerTooltip: this.bankBuildContingencyPlan,
        valueGetter: (params) => {
          return params.data?.bankbuildoncontingencyplan === true ? 'Checked' : 'Unchecked';
        }
      },
      {
        headerName: this.bankVerifiedN1,
        field: 'bankbuildverifiedbyn1', flex: 1,
        cellRenderer: CheckboxFieldComponent,
        floatingFilterComponent: DropdownFieldFilterComponent, floatingFilter: true,
        floatingFilterComponentParams: {
          associatedList: ['All','Checked','Unchecked']
        },
        valueGetter: (params) => {
          return params.data?.bankbuildverifiedbyn1 === true ? 'Checked' : 'Unchecked';
        },
        headerTooltip: this.bankVerifiedN1
      },
      {
        headerName: this.expectedNewContractCompletionDate,
        field: 'expectedcompletion', flex: 1,
        filter: 'agDateColumnFilter', filterParams: this.dateFilterParams,
        cellRenderer: DateFieldComponent,
        headerTooltip: this.expectedNewContractCompletionDate
      },
      {
        headerName: this.contingencyPlan,
        field: 'contingencyplan', flex: 1,
        cellRenderer: CheckboxFieldComponent,
        floatingFilterComponent: DropdownFieldFilterComponent,
        floatingFilter: true,
        floatingFilterComponentParams: {
          associatedList: ['All','Checked','Unchecked']
        },
        valueGetter: (params) => {
          return params.data?.contingencyplan === true ? 'Checked' : 'Unchecked';
        },
        headerTooltip: this.contingencyPlan
      },
      {
        headerName: 'Contingency Plan Summary',
        field: 'contigencyplansummary', width: 240,
        comparator: this.sortService.stringComparator
      },
      {
        headerName: 'Overall Evaluation',
        field: 'evaluation', flex: 1,
        cellRenderer: DropdownFieldComponent,
        floatingFilterComponent: DropdownFieldFilterComponent,
        floatingFilter: true,
        floatingFilterComponentParams: {
          associatedList: this.evaluationValues
        }
      },
      {
        headerName: 'Buyer',
        field: 'buyer', flex: 1,
        comparator: this.sortService.stringComparator
      },
      {
        headerName: 'Manager',
        field: 'manager', flex: 1,
        comparator: this.sortService.stringComparator
      },
      {
        headerName: 'Senior Manager',
        field: 'seniormanager', flex: 1,
        comparator: this.sortService.stringComparator
      },
      {
        headerName: 'Signed Contingency Plan (DMH)', field: 'signedcontingencyfile', flex: 1,
        comparator: this.sortService.stringComparator,
        cellRenderer: (params) => {
          if(params?.value !== null && params?.value !== undefined) {
            return `<a class="linkClick">${this.fileNameDownloadReports(params.value)}</a>`;
          } else {
            return '';
          }
        },
        onCellClicked: (params) => {
          // Handle the click event for the contract file
          if (params.column.getColId() === 'signedcontingencyfile' && params.data.signedcontingencyfile) {
            // Check if the clicked cell belongs to the 'signedcontingencyfile' column and has a value
            const fileUrl = params.data.signedcontingencyfile; // Assuming params.value holds the direct URL to the PDF
            this.contractContingencyFileDownload(fileUrl)
          }else{
            this.ngxSpinner.hide()
            this.showErrorMessageReports(this.errorService.downloadFileErrMsg)
          }
        }
      },
      {
        headerName: 'Contract (DMH)', field: 'contractfile', flex: 1,
        comparator: this.sortService.stringComparator,
        cellRenderer: (params) => {
          if(params?.value !== null && params?.value !== undefined) {
            return `<a class="linkClick">${this.fileNameDownloadReports(params.value)}</a>`;
          } else {
            return '';
          }
        },
        onCellClicked: (params) => {
          // Handle the click event for the contract file
          if (params.column.getColId() === 'contractfile' && params.data.contractfile) {
            // Check if the clicked cell belongs to the 'contractfile' column and has a value
            const fileUrl = params.data.contractfile; // Assuming params.value holds the direct URL to the PDF
            this.contractContingencyFileDownload(fileUrl)
          }else{
            this.ngxSpinner.hide()
            this.showErrorMessageReports(this.errorService.downloadFileErrMsg)
          }
        }
      }
    ]
  }

  fileNameDownloadReports(value) {
    if(!value) {
      return '';
    } else {
      return value.split('/').pop();
    }
  }

  setColumnDataValuesAll() {
    this.columnDefAllSupplierDetails = [{
        headerName: 'Action', field: 'action', width: 80, minWidth: 80, filter: false,
        enableRowGroup: false, lockPosition: true, sortable: false, cellRenderer: SupplierDetailsEditComponent,
        cellRendererParams: {
          update: this.updateSupplierDetailsReports.bind(this),
          cancel: this.cancelUpdateReports.bind(this),
        }, pinned: 'left', lockPinned: true,
      },
      {
        headerName: 'Supplier Code', field: 'suppliercode', width: 140,
        lockPosition: true, pinned: 'left', lockPinned: true,
      },
      {
        headerName: 'Supplier Name', field: 'suppliername', width: 140,
        lockPosition: true, pinned: 'left', lockPinned: true, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Commodity', field: 'commodity', width: 180, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'NAMCs Supplied', field: 'namc', flex: 1, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'City', field: 'plantcity', flex: 1, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'State', field: 'plantstate', flex: 1, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Union Name (DMH)', field: 'unionname', flex: 1, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Union Type', field: 'uniontype', flex: 1, cellRenderer: DropdownFieldComponent, floatingFilterComponent: DropdownFieldFilterComponent,
        floatingFilter: true, floatingFilterComponentParams: { associatedList: this.unionTypeValues },
      },
      {
        headerName: 'Contract Expiration Date (DMH)', field: 'expirationdate', flex: 1,
        filter: 'agDateColumnFilter', filterParams: this.dateFilterParams,
        cellRenderer: (params) => { return this.formatDate(params.value) }
      },
      {
        headerName: 'N-Date', field: 'n_date', flex: 1, sortable: false, 
      },
      {
        headerName: 'Legit Planned Date', field: 'legitimizationdate', flex: 1,
        filter: 'agDateColumnFilter', filterParams: this.dateFilterParams, cellRenderer: DateFieldComponent,
      },
      {
        headerName: 'Legit Complete', field: 'legitimizationstatus', flex: 1,
        cellRenderer: DropdownFieldComponent,floatingFilterComponent: DropdownFieldFilterComponent, floatingFilter: true,
        floatingFilterComponentParams: { associatedList: this.legitStatusValues },
      },
      {
        headerName: "MX Gov't. Apprvl. Date (DMH)", field: 'mxapprovaldate', flex: 1,
        filter: 'agDateColumnFilter', filterParams: this.dateFilterParams,
        cellRenderer: (params) => { return this.formatDate(params.value) }
      },
      {
        headerName: 'Overall Status Comment', field: 'comment', width: 240, suppressKeyboardEvent: (params) => this.keyboardActionsReports(params),
        cellRenderer: TextareaFieldComponent, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Status', field: 'unionstatus', width: 240,
        cellRenderer: DropdownFieldComponent, floatingFilterComponent: DropdownFieldFilterComponent, floatingFilter: true,
        floatingFilterComponentParams: { associatedList: this.unionStatusValues }, comparator: this.sortService.stringComparator,
        cellStyle: (params) => {
          if(params.value === this.unionStatusValues[1]) { return { backgroundColor: '#ff7276' }
          } else if(params.value === this.unionStatusValues[2]) { return { backgroundColor: '#FFA500' }
          } else if((params.value === this.unionStatusValues[3]) || (params.value === this.unionStatusValues[7])) {
            return { backgroundColor: '#c4ee90' }  
          } else if(params.value === this.unionStatusValues[4]) { return { backgroundColor: '#ffe900' }
          } else if((params.value === this.unionStatusValues[5]) || (params.value === this.unionStatusValues[6])){
            return { backgroundColor: '#f1abb9' }
          } else if(params.value === this.unionStatusValues[8]) { return { backgroundColor: '#00b740' }
          } else if(params.value === this.unionStatusValues[9]) { return { backgroundColor: '#b9b9b9' }}
          return null;
        },
        cellClass: (params) => { 
          if(params.value === this.unionStatusValues[1]) { return 'statusRed'
          } else if(params.value === this.unionStatusValues[2]) { return 'statusOrange'
          } else if((params.value === this.unionStatusValues[3]) || (params.value === this.unionStatusValues[7])) {
            return 'statusLightGreen'
          } else if(params.value === this.unionStatusValues[4]) { return 'statusYellow'
          } else if((params.value === this.unionStatusValues[5]) ||  (params.value === this.unionStatusValues[6])){
            return 'statusLightPink'
          } else if(params.value === this.unionStatusValues[8]) { return 'statusGreen'
          } else if(params.value === this.unionStatusValues[9]) { return 'statusGrey' }
          return null;
        }
      },
      {
        headerName: 'Inventory Bank (Days)', field: 'inventorybank', flex: 1
      },
      {
        headerName: this.bankBuildContingencyPlan, field: 'bankbuildoncontingencyplan', flex: 1, cellRendererParams: { editable: false },
        cellRenderer: CheckboxFieldComponent, floatingFilterComponent: DropdownFieldFilterComponent,
        floatingFilter: true, floatingFilterComponentParams: { associatedList: ['All', 'Checked', 'Unchecked'] },
        valueGetter: (params) => { return params.data?.bankbuildoncontingencyplan === true ? 'Checked': 'Unchecked'; },
        headerTooltip: this.bankBuildContingencyPlan,
      },
      {
        headerName: this.bankVerifiedN1, field: 'bankbuildverifiedbyn1', flex: 1, cellRendererParams: { editable: false },
        cellRenderer: CheckboxFieldComponent, floatingFilterComponent: DropdownFieldFilterComponent,
        floatingFilter: true, floatingFilterComponentParams: { associatedList: ['All', 'Checked', 'Unchecked'] },
        valueGetter: (params) => { return params.data?.bankbuildverifiedbyn1 === true ? 'Checked' : 'Unchecked'; },
        headerTooltip: this.bankVerifiedN1,
      },
      {
        headerName: this.expectedNewContractCompletionDate, field: 'expectedcompletion', flex: 1,
        filter: 'agDateColumnFilter', filterParams: this.dateFilterParams, headerTooltip: this.expectedNewContractCompletionDate,
        cellRenderer: (params) => { return this.formatDate(params.value) }
      },
      {
        headerName: this.contingencyPlan, field: 'contingencyplan', flex: 1, cellRendererParams: { editable: false },
        cellRenderer: CheckboxFieldComponent, floatingFilterComponent: DropdownFieldFilterComponent,
        floatingFilter: true, floatingFilterComponentParams: { associatedList: ['All', 'Checked', 'Unchecked'] },
        valueGetter: (params) => { return params.data?.contingencyplan === true ? 'Checked' : 'Unchecked'; },
        headerTooltip: this.contingencyPlan,
      },
      {
        headerName: 'Contingency Plan Summary', field: 'contigencyplansummary',
        width: 240, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Overall Evaluation', field: 'evaluation', flex: 1,
        cellRenderer: DropdownFieldComponent, floatingFilterComponent: DropdownFieldFilterComponent,
        floatingFilter: true, floatingFilterComponentParams: { associatedList: this.evaluationValues },
      },
      {
        headerName: 'Primary Sales Contact', field: 'primarysalescontact', flex: 1, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Email', field: 'primarysalescontactemail', flex: 1, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Buyer', field: 'buyer', flex: 1, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Manager', field: 'manager', flex: 1, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Senior Manager', field: 'seniormanager', flex: 1, comparator: this.sortService.stringComparator,
      },
      {
        headerName: 'Monthly Confirmation', field: 'monthlyconfirmation', flex: 1,
        cellRenderer: CheckboxFieldComponent, floatingFilterComponent: DropdownFieldFilterComponent,
        floatingFilter: true, floatingFilterComponentParams: { associatedList: ['All', 'Checked', 'Unchecked'] },
        valueGetter: (params) => { return params.data?.monthlyconfirmation === true ? 'Checked' : 'Unchecked'; },
      },
      {
        headerName: 'Signed Contingency Plan (DMH)', field: 'signedcontingencyfile', flex: 1,
        comparator: this.sortService.stringComparator,
        cellRenderer: (params) => {
          if(params?.value !== null && params?.value !== undefined) {
            return `<a class="linkClick">${this.fileNameDownloadReports(params.value)}</a>`;
          } else {
            return '';
          }
        },
        onCellClicked: (params) => {
          if (params.column.getColId() === 'signedcontingencyfile' && params.data.signedcontingencyfile) {
            const fileUrl = params.data.signedcontingencyfile; // Assuming params.value holds the direct URL to the PDF
            this.contractContingencyFileDownload(fileUrl)
          }else{
            this.ngxSpinner.hide()
            this.showErrorMessageReports(this.errorService.downloadFileErrMsg)
          }
        }
      },
      {
        headerName: 'Contract (DMH)', field: 'contractfile', flex: 1, comparator: this.sortService.stringComparator,
        cellRenderer: (params) => {
          if(params?.value !== null && params?.value !== undefined) {
            return `<a class="linkClick">${this.fileNameDownloadReports(params.value)}</a>`;
          } else {
            return '';
          }
        },
        onCellClicked: (params) => {
          if (params.column.getColId() === 'contractfile' && params.data.contractfile) {
            const fileUrl = params.data.contractfile; // Assuming params.value holds the direct URL to the PDF
            this.contractContingencyFileDownload(fileUrl)
          }else{
            this.ngxSpinner.hide()
            this.showErrorMessageReports(this.errorService.downloadFileErrMsg)
          }
        }
      },
    ];
  }

  contractContingencyFileDownload(fileUrl: any) {
    this.ngxSpinner.show()
    this.lookup.downloadContractOrSignedContingencyFile(fileUrl).subscribe({
    next: data=>{
      if(data['statusCode'] === 200){
        window.open(data.body.url, '_blank'); // Open the PDF in a new tab/window for download or viewing
        this.ngxSpinner.hide()
      }else{
        this.ngxSpinner.hide()
        this.showErrorMessageReports(this.errorService.downloadFileErrMsg)
      }
    },
    error: _error=>{ 
      this.ngxSpinner.hide()
      this.showErrorMessageReports(this.errorService.downloadFileErrMsg)
    }});
  }

  showErrorMessageReports(message) {
    this.showErrorMsg = true
    this.showNoSupplierErrMsg = true
    this.pageErrorMsg = message
    setTimeout(()=>{
      this.showErrorMsg = false
      this.showNoSupplierErrMsg = false
    }, 10000)
  }

  keyboardActionsReports(params) {
    const event = params.event;
    const target = event.target as HTMLElement;
    const isTextInput = target.tagName === 'TEXTAREA' || target.tagName === 'INPUT';
    if (isTextInput) {
      const key = event.key.toLowerCase();
      const isCtrlCombo = (event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(key);
      const isArrowKey = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key);
      if (isCtrlCombo || isArrowKey) {
        return true; // Suppress ag-Grid handling; allow default browser behavior
      }
    }
    return false;
  }

  async getHistoryDataDetails(reportId, employeeId, page) {
    this.ngxSpinner.show()
    try { 
      const data = await lastValueFrom(this.lookup.getReportHistoryDetails(page, this.limit, 'history', reportId, employeeId))
      if(data['statusCode']===200 && data?.body?.history && data?.body?.history?.length > 0 && !data?.body?.errorResponse) {
        //setting total number of packets
        if(page === 1) {
          this.rowdataForHistorySupplierDetails = []
        }
        //If page is greater than 1, then push data to the rowData
        if(page>1) {
          this.ngxSpinner.hide();
          this.rowdataForHistorySupplierDetails = [...this.rowdataForHistorySupplierDetails, ...data.body.history]
        } else {
          this.rowdataForHistorySupplierDetails = data?.body?.history;
        }
        //If history response length equal to 1000, call the api again to fetch date from next page
        if(data?.body?.history?.length === this.limit) {
          page += 1;
          this.getHistoryDataDetails(reportId, employeeId, page)
        }
        this.disableExportHistory = false
      } else {
        window.scroll(0,0);
        this.ngxSpinner.hide()
        this.disableExportHistory = true
        this.rowdataForHistorySupplierDetails = []
        this.showErrorMessageReports(this.errorService.noHistoryDetailsAvailable)
      }
    } catch {
      window.scroll(0,0);
      this.ngxSpinner.hide()
      this.disableExportHistory = true
      this.rowdataForHistorySupplierDetails = []
      this.showErrorMessageReports(this.errorService.serverErrMsg)
    } finally {
      this.ngxSpinner.hide()
    }
  }

  async getAllDataDetails(employeeId, page) {
    this.ngxSpinner.show()
    try { 
      const data = await lastValueFrom(this.lookup.getReportAllDetails(page, this.limit, 'all', employeeId))
      if(data['statusCode']===200 && data?.body?.all && data?.body?.all?.length > 0 && !data?.body?.errorResponse) {
        //setting total number of packets
        if(page === 1) {
          this.rowdataForAllSupplierDetails = []
        }
        //If page is greater than 1, then push data to the rowData
        if(page>1) {
          this.ngxSpinner.hide();
          this.rowdataForAllSupplierDetails = [...this.rowdataForAllSupplierDetails, ...data.body.all]
        } else {
          this.rowdataForAllSupplierDetails = data?.body?.all;
        }
        //If all response length equal to 1000, call the api again to fetch date from next page
        if(data?.body?.all?.length === this.limit) {
          page += 1;
          this.getAllDataDetails(employeeId, page)
        }
        this.disableExportAll = false
      } else {
        window.scroll(0,0);
        this.ngxSpinner.hide()
        this.disableExportAll = true
        this.rowdataForAllSupplierDetails = []
        this.showErrorMessageReports(this.errorService.noAllDetailsAvailable)
      }
    } catch {
      window.scroll(0,0);
      this.ngxSpinner.hide()
      this.disableExportAll = true
      this.rowdataForAllSupplierDetails = []
      this.showErrorMessageReports(this.errorService.serverErrMsg)
    } finally {
      this.ngxSpinner.hide()
    }
  }

  updateSupplierDetailsReports(params){  //NOSONAR
    this.ngxSpinner.show()
    this.lookup.getFilterData().subscribe(data => {
      this.filterDataValue = data.body
    })
    this.showSuccessMsg = false
    this.showErrorMsg = false
    this.showUnionTypeErrMsg = false
    this.showEvaluationErrMsg = false
    this.showOverallStatusCommentErrMsg = false
    const updateDataRequestBody = {
      "unionId": params.rowData?.unionid,
      "empId": this.employeeId,
      "unionTypeId": this.getUnionTypeId(params.rowData?.uniontype),
      "legitDate": params.rowData?.legitimizationdate,
      "legitStatus": params.rowData?.legitimizationstatus,
      "comment": params.rowData?.comment?.trim(),
      "unionStatusId": this.getUnionStatusId(params.rowData?.unionstatus),
      "evaluation": this.getEvaluationValue(params.rowData?.evaluation),
    }
    if((updateDataRequestBody.unionTypeId !== '' && updateDataRequestBody.unionTypeId != null && updateDataRequestBody.unionTypeId !== this.noneSelected) &&
      (updateDataRequestBody.evaluation !== '' && updateDataRequestBody.evaluation != null) && (updateDataRequestBody.comment !== '' && updateDataRequestBody.comment != null)) {
      this.management.updateReportData(updateDataRequestBody).subscribe((data) => {
        if(data.statusCode === 200 && !data?.body?.errorResponse) {
          this.getAllDataDetails(this.employeeId, 1)
          this.showSuccessMsg = true
          this.successMssg = 'Data Updated Successfully.'
          setTimeout(()=>{
            this.showSuccessMsg = false
          }, 10000)
        } else {
          this.ngxSpinner.hide()
          this.showErrorMessageReports(this.errorService.dataUpdateFailure)
        }
        window.scroll(0,0);
      })
    } else {
      this.ngxSpinner.hide()
      window.scroll(0,0);
      if(updateDataRequestBody.unionTypeId === this.noneSelected || updateDataRequestBody.unionTypeId === '' || updateDataRequestBody.unionTypeId == null) {
        this.showErrorMsg = true
        this.showUnionTypeErrMsg = true
        this.unionTypeErrorMsg = this.errorService.unionTypeErrorMsg
        setTimeout(()=>{
          this.showErrorMsg = false
          this.showUnionTypeErrMsg = false
        }, 10000)
      }
      if(updateDataRequestBody.evaluation === '' || updateDataRequestBody.evaluation == null) {
        this.showErrorMsg = true
        this.showEvaluationErrMsg = true
        this.evaluationErrorMsg = this.errorService.evaluationErrorMsg
        setTimeout(()=>{
          this.showErrorMsg = false
          this.showEvaluationErrMsg = false
        }, 10000)
      }
      if(updateDataRequestBody.comment === '' || updateDataRequestBody.comment == null) {
        this.showErrorMsg = true
        this.showOverallStatusCommentErrMsg = true
        this.overallStatusCommentErrorMsg = this.errorService.statusCommentErrorMsg
        setTimeout(()=>{
          this.showErrorMsg = false
          this.showOverallStatusCommentErrMsg = false
        }, 10000)
      }
    }
  }

  cancelUpdateReports(_params){  //NOSONAR
    this.showErrorMsg = false
  }

  getEvaluationValue(value) {
    if(value !== null && value !== undefined) {
      const selectedEvaluation = this.filterDataValue?.evaluation.find((item) => item.greekletter === value || item.symbol === value)
      if(selectedEvaluation !== undefined) {
        return selectedEvaluation.symbol
      } else {
        return null
      }
    }
    return value
  }

  getUnionTypeId(value) {
    if(value !== null && value !== undefined) {
      if(value === this.noneSelected) {
        return value
      } else {
        const selectedUnionType = this.filterDataValue?.unionType.find((item) => item.uniontypeid === value || item.uniontype === value)
        if(selectedUnionType !== undefined) {
          return selectedUnionType.uniontypeid
        } else {
          return null
        }
      }
    }
    return value
  }

  getUnionStatusId(value) {
    if(value !== null && value !== undefined) {
      const selectedUnionStatus = this.filterDataValue?.unionStatus.find((item) => item.unionstatusid === value || item.unionstatus === value)
      if(selectedUnionStatus !== undefined) {
        return selectedUnionStatus.unionstatusid;
      } else {
        return null;
      }
    }
    return value
  }

  getSelectedReportPeriod(reportId) {
    const numbericReportId = Number(reportId)
    const reportPeriodName = this.reportPeriodData.find((val) => val.unionreportperiodid === numbericReportId)
    this.selectedReportPeriodName = reportPeriodName?.name
    this.rowdataForHistorySupplierDetails = []
    this.getHistoryDataDetails(reportId, this.employeeId, 1)
  }

  tabToNextCell(){ //tab to next cell in ag-grid table
  }

  exportTypeHistory(value) {
    if(value === 'xlsx') {
      this.downloadFileFormatHistory = 'xlsx'
    } else if (value === 'xls') {
      this.downloadFileFormatHistory = 'xls'
    } else {
      this.downloadFileFormatHistory = 'csv'
    }
  }

  exportTypeAll(value) {
    if(value === 'xlsx') {
      this.downloadFileFormatAll = 'xlsx'
    } else if (value === 'xls') {
      this.downloadFileFormatAll = 'xls'
    } else {
      this.downloadFileFormatAll = 'csv'
    }
  }

  async exportGridData(gridId) {
    this.ngxSpinner.show()
    const date = new Date();
    const formattedDate = formatDate(date, 'M_d_y_h_mma', 'en-US');
    const ignoreFirstColumn = this.columnDefAllSupplierDetails.map(col => col.field).filter(field => field !== 'action'); //ignoring Action column in 'Reports -> All Tab', as Edit functionality is only for 'All tab' and not for 'History Tab'.
    const exportParams = {
      fileName: gridId === 'grid1' ? 'Union Tracker Archive-'+`${formattedDate}`+`.${this.downloadFileFormatHistory}` :
        'Union Tracker All-'+`${formattedDate}`+`.${this.downloadFileFormatAll}`,
      sheetName: gridId === 'grid1' ? this.selectedReportPeriodName : 'All',
      columnKeys: ignoreFirstColumn,
      processCellCallback: (params) => {
        if((params.column.getColId() === 'monthlyconfirmation') || (params.column.getColId() === 'contingencyplan') ||
          (params.column.getColId() === 'bankbuildverifiedbyn1') || (params.column.getColId() === 'bankbuildoncontingencyplan')) {
          if(params.value === 'Checked') {
            params.value = 'Yes'
          } else if(params.value === 'Unchecked'){
            params.value = 'No'
          }
          return params.value
        }
        if((params.column.getColId() === 'expirationdate') || (params.column.getColId() === 'legitimizationdate') || (params.column.getColId() === 'expectedcompletion')) {
          return this.formatDate(params.value)
        }
        return params.value
      }
    }
    await new Promise((resolve)=> {
      if(gridId === 'grid1') {
        if(this.downloadFileFormatHistory === 'csv') {
          this.gridApiMap.get(gridId).exportDataAsCsv(exportParams)
        } else if(this.downloadFileFormatHistory === 'xls') {
          this.gridApiMap.get(gridId).exportDataAsExcel(exportParams)
        } else {
          this.gridApiMap.get(gridId).exportDataAsExcel(exportParams)
        }
      }   else if(gridId === 'grid2') {
        if(this.downloadFileFormatAll === 'csv') {
          this.gridApiMap.get(gridId).exportDataAsCsv(exportParams)
        } else if(this.downloadFileFormatAll === 'xls') {
          this.gridApiMap.get(gridId).exportDataAsExcel(exportParams)
        } else {
          this.gridApiMap.get(gridId).exportDataAsExcel(exportParams)
        }
      }
      setTimeout(resolve, this.estimateExportTimeReport(gridId));
    })
    this.ngxSpinner.hide()
  }

  formatDate(value: string): string {
    if (!value) {
      return '';
    } else {
      const isoformattedDate = value.replace(' ', 'T');
      const parsedDate = new Date(isoformattedDate);
      if (isNaN(parsedDate.getTime())) {
        return 'Invalid Date';
      } else {
        return new Intl.DateTimeFormat('en-US', {
          timeZone: 'UTC',
          year: 'numeric',
          month: 'numeric',
          day: '2-digit',
        }).format(parsedDate);
      }
    }
  }

  estimateExportTimeReport(gridId): number {
    return this.gridApiMap.has(gridId) ? this.calculateTimeReport(gridId) : 0; 
  }

  calculateTimeReport(gridId) {
    const rows = this.gridApiMap.get(gridId)?.getDisplayedRowCount();
    return Math.min(5000, rows * 10);
  }

  onGridReady(params: any, gridId: string) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApiMap.set(gridId, params.api);
    this.autoSizeAllColumns();
  }

  @HostListener('window:resize', ['$event'])
  onResize(_event: any) {
    if (this.gridApi) {
      this.debounce(() => {
        this.autoSizeAllColumns();
      }, 100);
    }
  }

  autoSizeAllColumns() {
    const allColumnIds: string[] = [];
    this.gridColumnApi?.getAllColumns().forEach((column: any) => {
      allColumnIds.push(column.getColId());
    });
    this.gridColumnApi?.autoSizeColumns(allColumnIds);
  }

  debounce(func: Function, wait: number) {
    let timeout: any;
    return (...args: any[]) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  cancelNullGuidAssume() {
    this.displayUnauthorized = false;
    this.displayScreen = true;
    localStorage.clear();
    location.reload();
  }

  ngOnDestroy(){ this.checkValidity?.unsubscribe(); }
}